export enum RuleDescriptionKind {
  DESCRIPTION_ONLY = 'descriptionOnly',
  DESCRIPTION_WITH_CLAUSE_SUMMARY = 'descriptionWithClauseSummary',
  CLAUSE_SUMMARY = 'clauseSummary',
  REORDERED_RULE = 'reorderedRule',
}
